// extracted by mini-css-extract-plugin
export default {"wrapper":"WorksList_wrapper__Rm8m1"};